export const PermissionsEnum = {
	None: 0,
	ViewReports: 1,
	ViewStatuses: 2,
	UnmanageDevices: 4,
	LockUnlockDevices: 8,
	CreateUsers: 16,
	SendMessages: 32,
	ModifyBrands: 64,
};

/**
 * Will return true if the user can perform the given permission. It's not enough
 * to call this code on the client-side. Someone can potentially modify the user
 * object through the Dev Console; so, we need to make sure we call this code on
 * the server-side, as well.
 *
 * @param {*} user The User object.
 * @param {*} permission The Permission to check whether the user has access to.
 */
export function checkPermission(user, permission) {
	// If user is null, return false.
	if (!user) {
		return false;
	}

	if (user.isConversaEmployee) {
		return true;
	}

	return user.permissions & permission;
}

export function getAllPermissions(user) {
    // If Conversa employee, then the user has access to all permissions.
	if (user.isConversaEmployee) {
        // Filter out the None permission (equal to 0).
        return Object.values(PermissionsEnum).filter(p => p !== 0);
	}

    const userPermissions = [];
	for (let permission in PermissionsEnum) {
		if (user.permissions & PermissionsEnum[permission]) {
			if (PermissionsEnum[permission] > 0) {
				userPermissions.push(PermissionsEnum[permission]);
			}
		}
	}
	return userPermissions;
}

/**
 * Given an array of permission values, will return a new int which is the result of
 * all flags added together.
 *
 * @param {*} permissions The list of permission values [1, 2, 4, 64, ...]
 */
export function getPermissionsAsInt(permissions) {
	return permissions.reduce((acc, val) => {
		return acc |= val;
	}, 0);
}
